var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20306 4.97299C5.20306 7.51741 7.27367 9.58803 9.8181 9.58803C12.3625 9.58803 14.4331 7.51741 14.4331 4.97299C14.4331 2.42856 12.3625 0.357941 9.8181 0.357941C7.27367 0.357941 5.20306 2.42856 5.20306 4.97299ZM18.0226 19.8437H19.0482V18.8181C19.0482 14.8605 15.8269 11.6392 11.8692 11.6392H7.76697C3.80829 11.6392 0.588013 14.8605 0.588013 18.8181V19.8437H18.0226Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRegister);
export default __webpack_public_path__ + "static/media/userRegister.a7698e121521d14f1b6941342e9a653f.svg";
export { ForwardRef as ReactComponent };